/**
 * PDP brand-wall 로고 마퀴 (우→좌 자동 스크롤).
 *
 * 섹션 {% javascript %} 인라인 번들(compiled_assets/scripts.js)이 서버 컴파일 단계에서
 * truncate 되는 이슈가 있어, 이 컴포넌트만 외부 asset 으로 분리해 독립 로드한다.
 * (번들 절단과 무관하게 customElements.define 이 실행되도록 보장)
 */
(function () {
  'use strict';
  if (customElements.get('piyonna-pdp-brand-wall-component')) return;

  class PiyonnaPdpBrandWallComponent extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.piyonna-pdp-brand-wall-section__track');
      this.firstHalf = this.querySelector('.piyonna-pdp-brand-wall-section__track-half');
      if (!this.track || !this.firstHalf) return;

      this.speed = 15; // px/s (Figma spec)
      this.offset = 0;
      this.setWidth = 0;
      this.lastTs = null;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this._tick = this.tick.bind(this);
      this._onResize = this.measure.bind(this);
      window.addEventListener('resize', this._onResize);
      this.measure();
      this.raf = requestAnimationFrame(this._tick);
    }

    measure() {
      // 한 벌 너비 + trailing gap(8px). 두 번째 ul 의 ml-[8px] 와 짝을 맞춰 seamless loop 유지.
      this.setWidth = this.firstHalf.getBoundingClientRect().width + 8;
    }

    apply() {
      if (!this.setWidth || this.setWidth <= 0) return;
      let o = this.offset % this.setWidth;
      if (o < 0) o += this.setWidth;
      this.track.style.transform = 'translateX(' + -o + 'px)';
    }

    tick(ts) {
      if (this.lastTs === null) this.lastTs = ts;
      const dt = (ts - this.lastTs) / 1000;
      this.lastTs = ts;
      if (!this.reduceMotion) {
        this.offset += this.speed * dt;
      }
      this.apply();
      this.raf = requestAnimationFrame(this._tick);
    }

    disconnectedCallback() {
      if (this.raf) cancelAnimationFrame(this.raf);
      if (this._onResize) window.removeEventListener('resize', this._onResize);
    }
  }

  customElements.define('piyonna-pdp-brand-wall-component', PiyonnaPdpBrandWallComponent);
})();
